import { UserPrivate } from '@upright/common/iam/users/types';
import { isCompanyStandardLicenseUser } from '@upright/common/utils';
import { useGetCPProductSetForCompanyQuery } from '@upright/ui/api/model/input/blanket/product-weight-form';
import { ClientType, FrontPage } from '@upright/ui/views/home-views/front-page-config';
import { createCompanySectionTitle } from './company-section';
import { generateHomeUrl } from '@upright/ui/common/generic/components/bou-tool-header/mobile-header/burger-menu/logged-in-block/investor-block/frontpage-links';
import { generateCompanyInputFormLink } from '@upright/ui/views/home-views/shared/utils';
import { Item, ItemLink, Section, MenuTitleSmall } from '../../../shared-menus';

interface Props {
  company: { id: string; name: string } | null | undefined;
  user: UserPrivate | undefined;
  clientType: ClientType;
  frontPage: FrontPage;
  organizationName: string | undefined;
}

export const CompanyBlock = (props: Props) => {
  const productSetQuery = useGetCPProductSetForCompanyQuery(props.company?.id);
  const productSetData = productSetQuery.data;
  const isCompanyStandardTier = isCompanyStandardLicenseUser(props.user);
  const companyTitle = createCompanySectionTitle(props.clientType, props.company?.name, props.organizationName);
  const isCompanyFrontPage = props.frontPage === 'company';

  return (
    <Section>
      <MenuTitleSmall>{companyTitle}</MenuTitleSmall>
      <Item>
        <ItemLink to={generateHomeUrl({ entity: 'company', isCompanyFrontPage })}>Dashboard</ItemLink>
      </Item>
      {props.company && productSetData?.accessToken && (
        <Item>
          <ItemLink to={generateCompanyInputFormLink('products', props.company, productSetData) ?? '#'}>
            Products
          </ItemLink>
        </Item>
      )}
      {isCompanyStandardTier && props.company && (
        <>
          <Item>
            <ItemLink to={generateCompanyInputFormLink('insights', props.company) ?? '#'}>Insights</ItemLink>
          </Item>
          <Item>
            <ItemLink to={generateCompanyInputFormLink('targets', props.company) ?? '#'}>Targets</ItemLink>
          </Item>
        </>
      )}
    </Section>
  );
};
